// HouseInfo.js
import React from "react";
import { FormGroup, Label, Input, Button } from "reactstrap";
import { formOptions } from "./constants";
import { Backlog } from "./Backlog";

const HouseInfo = ({ formData, handleChange, errors, isBacklog, desaOptions }) => {
  const handlePekerjaanManualSwitch = () => {
    handleChange({ target: { name: "isPekerjaanManual", value: false } });
    handleChange({ target: { name: "pekerjaan", value: "" } });
  };

  const handlePenghasilanManualSwitch = () => {
    handleChange({ target: { name: "isPenghasilanManual", value: false } });
    handleChange({ target: { name: "penghasilan", value: "" } });
  };

  return (
    <>
      <FormGroup>
        <Label for="jumlahKK">9. Jumlah KK Dalam Rumah</Label>
        <Input
          type="number"
          name="jumlahKK"
          id="jumlahKK"
          value={formData.jumlahKK || ""}
          onChange={handleChange}
          disabled={formData.statusrumah === "Tidak Berpenghuni"}
          className={errors.jumlahKK ? "is-invalid" : ""} 
        />
        {errors.jumlahKK && <div className="invalid-feedback">{errors.jumlahKK}</div>}

        {isBacklog && (
          <div className="info-message">
            Rumah ini dianggap "Backlog" karena terdapat lebih dari 1 KK.
          </div>
        )}
      </FormGroup>

      {/* Form Backlog tampil di bawah form Jumlah KK */}
      {isBacklog && (
        <Backlog
          formData={formData}
          handleChange={handleChange}
          errors={errors}
        />
      )}

      <FormGroup>
        <Label for="jumlahPenghuni">10. Jumlah Penghuni</Label>
        <Input 
          type="number" 
          name="jumlahPenghuni" 
          id="jumlahPenghuni" 
          value={formData.jumlahPenghuni || ""} 
          onChange={handleChange} 
          disabled={formData.statusrumah === "Tidak Berpenghuni"}
          className={errors.jumlahPenghuni ? "is-invalid" : ""} 
        />
        {errors.jumlahPenghuni && <div className="invalid-feedback">{errors.jumlahPenghuni}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="alamatRumah">11. Alamat Rumah (RT/RW/Dusun/Lingkungan)</Label>
        <Input 
          type="text" 
          name="alamatRumah" 
          id="alamatRumah" 
          value={formData.alamatRumah} 
          onChange={handleChange}  
          className={errors.alamatRumah ? "is-invalid" : ""} 
        /> 
        {errors.alamatRumah && <div className="invalid-feedback">{errors.alamatRumah}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="kecamatan">12. Kecamatan</Label>
        <Input 
          type="select" 
          name="kecamatan" 
          id="kecamatan" 
          value={formData.kecamatan} 
          onChange={handleChange}
          className={errors.kecamatan ? "is-invalid" : ""} 
        >
          <option value="">Pilih</option>
          <option value="Taliwang">Taliwang</option>
          <option value="Seteluk">Seteluk</option>
          <option value="Poto Tano">Poto Tano</option>
          <option value="Brang Rea">Brang Rea</option>
          <option value="Brang Ene">Brang Ene</option>
          <option value="Jereweh">Jereweh</option>
          <option value="Maluk">Maluk</option>
          <option value="Sekongkang">Sekongkang</option>
        </Input>
        {errors.kecamatan && <div className="invalid-feedback">{errors.kecamatan}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="desaKelurahan">13. Desa/Kelurahan</Label>
        <Input 
          type="select" 
          name="desaKelurahan" 
          id="desaKelurahan" 
          value={formData.desaKelurahan} 
          onChange={handleChange}
          className={errors.kecamatan ? "is-invalid" : ""} 
        >
          <option value="">Pilih</option>
          {desaOptions.map((desa, index) => (
            <option key={index} value={desa}>
              {desa}
            </option>
          ))}
        </Input>
        {errors.desaKelurahan && <div className="invalid-feedback">{errors.desaKelurahan}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="pendidikanTerakhir">14. Pendidikan Terakhir</Label>
        <Input 
          type="select" 
          name="pendidikanTerakhir" 
          id="pendidikanTerakhir" 
          value={formData.pendidikanTerakhir} 
          onChange={handleChange} 
          disabled={formData.statusrumah === "Tidak Berpenghuni"}
          className={errors.pendidikanTerakhir ? "is-invalid" : ""} 
        >
          <option value="">Pilih</option>
          {formOptions.pendidikanTerakhir.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
        {errors.pendidikanTerakhir && <div className="invalid-feedback">{errors.pendidikanTerakhir}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="pekerjaan">15. Pekerjaan</Label>
        {!formData.isPekerjaanManual ? (
          <Input 
            type="select" 
            name="pekerjaan" 
            id="pekerjaan" 
            value={formData.pekerjaan} 
            onChange={handleChange}
            disabled={formData.statusrumah === "Tidak Berpenghuni"}
            className={errors.pekerjaan ? "is-invalid" : ""} 
          >
            <option value="">Pilih</option>
            {formOptions.pekerjaan.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Input>
        ) : (
          <div>
            <Input
              type="text"
              name="pekerjaan" // Corrected name to match state property
              id="pekerjaan"
              value={formData.pekerjaan || ''}
              onChange={handleChange}
              placeholder="Masukkan Pekerjaan"
            />
            <Button 
              color="link" 
              size="sm" 
              onClick={handlePekerjaanManualSwitch}
            >
              Kembali ke pilihan
            </Button>
          </div>
        )}
        {errors.pekerjaan && <div className="invalid-feedback">{errors.pekerjaan}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="fungsiBangunan">16. Fungsi Bangunan</Label>
        <Input 
          type="select" 
          name="fungsiBangunan" 
          id="fungsiBangunan" 
          value={formData.fungsiBangunan} 
          onChange={handleChange}
          className={errors.fungsiBangunan ? "is-invalid" : ""} 
        >
          <option value="">Pilih</option>
          {formOptions.fungsiBangunan.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
        {errors.fungsiBangunan && <div className="invalid-feedback">{errors.fungsiBangunan}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="penghasilan">17. Penghasilan/Bulan</Label>
        {!formData.isPenghasilanManual ? (
          <Input 
            type="select" 
            name="penghasilan" 
            id="penghasilan" 
            value={formData.penghasilan} 
            onChange={handleChange}
            disabled={formData.statusrumah === "Tidak Berpenghuni"}
            className={errors.penghasilan ? "is-invalid" : ""} 
          >
            <option value="">Pilih</option>
            {formOptions.penghasilan.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Input>
        ) : (
          <div>
            <Input
              type="number"
              name="penghasilan" // Corrected name to match state property
              id="penghasilan"
              value={formData.penghasilan || ''}
              onChange={handleChange}
              placeholder="Masukkan penghasilan"
            />
            <Button 
              color="link" 
              size="sm" 
              onClick={handlePenghasilanManualSwitch}
            >
              Kembali ke pilihan
            </Button>
          </div>
        )}
        {errors.penghasilan && <div className="invalid-feedback">{errors.penghasilan}</div>}
      </FormGroup>
    </>
  );
};

export default HouseInfo;